import DeltaWifiBanner from './DeltaWifiBanner';

export default DeltaWifiBanner;
